export class TilesModel {
    action: any ={
        type:null,
        value:null
    }; 
    title: string = '';
    isActive: boolean = true;
    caption: string = '';
    // description: any;
}